import type { Blocker, BlockerCategory, BlockerKey } from '../types/conversationState';

export type BlockerTemplate = {
  label: string;
  template: string;
  category: BlockerCategory;
};

export const BLOCKER_TEMPLATES: Record<BlockerKey, BlockerTemplate> = {
  outward_origin: { label: '出発地', template: '出発地: ', category: 'outward' },
  outward_destination: { label: '目的地', template: '目的地: ', category: 'outward' },
  outward_outdate: { label: '出発日', template: '出発日: ', category: 'outward' },
  outward_departure_time: { label: '出発時刻', template: '出発時刻: ', category: 'outward' },
  outward_arrival_time: { label: '到着時刻', template: '到着希望時刻: ', category: 'outward' },
  homeward_origin: { label: '帰り出発地', template: '帰りの出発地: ', category: 'homeward' },
  homeward_destination: { label: '帰り到着地', template: '帰りの到着地: ', category: 'homeward' },
  homeward_outdate: { label: '帰り出発日', template: '帰りの出発日: ', category: 'homeward' },
  homeward_departure_time: { label: '帰り出発時刻', template: '帰りの出発時刻: ', category: 'homeward' },
  homeward_arrival_time: { label: '帰り到着時刻', template: '帰りの到着希望時刻: ', category: 'homeward' },
  hotel_destination: { label: '宿泊エリア', template: '宿泊エリア: ', category: 'hotel' },
  hotel_checkin_date: { label: 'チェックイン日', template: 'チェックイン日: ', category: 'hotel' }
};

export const resolveBlockerTemplate = (blocker: Blocker): BlockerTemplate => {
  const template = (BLOCKER_TEMPLATES as Record<string, BlockerTemplate | undefined>)[blocker.key];
  return template ?? { label: '不明な項目', template: '', category: blocker.category };
};
